import React from "react";
import { Severity } from "../../constants/ProConstants";
import _ from 'lodash'

const ProDialogBody = ({icon, body, severity})=>{
    const iconColor = _.isEqual(severity, Severity.Danger)?'#CC280E':"";
    return (
       
        <div className="p-d-flex" >
            {!_.isEmpty(icon) && <div className="p-mr-2">
            <span className={icon} style={{ color:`${iconColor}`, fontSize:"48px"}}></span> 
            </div>}
            <div className="p-mr">
             <p>{body}</p>
            </div>
        </div>
      
    )

}

export default ProDialogBody;